import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { initTelemetry, trackPageView } from './telemetry';
/**
 * 텔레메트리 SDK를 초기화하고 라우트 변경 시 페이지뷰를 전송한다.
 * UI를 렌더하지 않으며, 앱 루트 근처에 한 번만 마운트한다.
 */
export function TelemetryPageTracker({ initOptions }) {
    const location = useLocation();
    // initTelemetry는 Clarity/App Insights 스크립트를 문서에 삽입한다.
    // hydrateRoot(document, ...)가 하이드레이션할 DOM을 건드리게 되므로,
    // 하이드레이션 커밋이 끝난 뒤에만 실행되도록 effect 안에서 호출한다.
    useEffect(() => {
        initTelemetry(initOptions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        trackPageView(location.pathname);
    }, [location.pathname]);
    return null;
}
//# sourceMappingURL=TelemetryPageTracker.js.map